import { API_ENDPOINTS } from "shared/constants";
import { APIService } from "shared/services";
import { build } from "shared/utils";

export interface IUploadData {
  filename: string;
}

export interface IUpload {
  url: string;
}

interface IUploadFile {
  name: string;
  type: string;
}

export class UploadService {
  static getUploadURL = (uploadData: IUploadData): Promise<string> =>
    new Promise(async (resolve, reject) => {
      try {
        const normalizedData = await APIService.post({
          path: API_ENDPOINTS.UPLOAD,
          data: uploadData,
        });
        const data = build(normalizedData, "uploadOutput");
        resolve(data[0].url);
      } catch (error) {
        reject(error);
      }
    });

  static uploadFile = (file: IUploadFile): Promise<IUpload> =>
    new Promise(async (resolve, reject) => {
      try {
        const uploadURL = await UploadService.getUploadURL({
          filename: file.name,
        });

        await APIService.put({
          path: uploadURL,
          data: file,
          headers: {
            "content-type": file.type,
          },
          options: {
            noAuth: true,
          },
        });
        resolve({
          url: uploadURL,
        });
      } catch (error) {
        reject(error);
      }
    });
}
